import * as ActionTypes from "../actions/actionTypes";

const initialState = {
  show: false,
  title: "foo",
  body: "bar",
  showClose: false,
  showConfirm: false,
  showCancel: false,
  confirmLabel: null,
  cancelLabel: null,
  onConfirm: null,
};

const modalReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SHOW_MODAL:
      state = {
        show: true,
        title: action.payload.title,
        body: action.payload.body,
        showClose: action.payload.showClose,
        showConfirm: action.payload.showConfirm,
        showCancel: action.payload.showCancel,
        confirmLabel: action.payload.confirmLabel,
        cancelLabel: action.payload.cancelLabel,
        onConfirm: action.payload.onConfirm,
      };
      break;
    case ActionTypes.HIDE_MODAL:
      state = initialState;
      break;
    default:
      break;
  }
  return state;
};

export default modalReducer;



// WEBPACK FOOTER //
// ./src/reducers/modalReducer.js